import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { v4 as uuidv4 } from "uuid";

const DashboardFAQ = () => {
  const webDevelopmentFAQs = [
    {
      id: uuidv4(),
      question:
        "What IT consulting services does Flint Infotech specialize in?",
      answer:
        "Flint Infotech specializes in a wide range of IT consulting services, including strategic technology planning, digital transformation, cybersecurity consulting, cloud solutions, web development, database migration, and IT infrastructure optimization. Our team is equipped to address diverse technology needs to drive business growth.",
    },
    {
      id: uuidv4(),
      question:
        "What sets Flint Infotech apart as an IT service and consulting firm?",
      answer:
        "Flint Infotech distinguishes itself through a comprehensive approach to IT solutions. Our team combines extensive industry expertise with a commitment to understanding our clients' unique challenges. We leverage strategic technology planning, digital transformation,  cloud solutions, web development, and database migration to offer tailored services that drive business growth. Our holistic approach ensures that clients receive not just services, but a partnership focused on optimizing their IT infrastructure for sustained success.",
    },
    {
      id: uuidv4(),
      question:
        "What industries does Flint Infotech serve with its IT services?",
      answer:
        "Flint Infotech serves a diverse clientele across various industries, including finance, healthcare, manufacturing, and more. Our tailored IT services are designed to meet the unique technology demands of each industry, fostering innovation and operational excellence.",
    },
    {
      id: uuidv4(),
      question:
        " How does Flint Infotech approach digital transformation for businesses?",
      answer:
        "Flint Infotech adopts a holistic approach to digital transformation, aligning technology solutions with your business goals. We focus on enhancing customer experiences, improving operational efficiency, and leveraging emerging technologies to drive innovation and sustainable growth.",
    },
    {
      id: uuidv4(),
      question: "Can Flint Infotech assist in cloud migration and management?",
      answer:
        "Yes, Flint Infotech has extensive expertise in cloud services, including migration, management, and optimization. Whether you are considering a move to the cloud or seeking to enhance your existing cloud infrastructure, our team provides comprehensive solutions tailored to your organization's needs.",
    },
    {
      id: uuidv4(),
      question: "What is website redesign?",
      answer:
        "Website redesign is the strategic process of overhauling and enhancing an existing website's design, layout, and functionality to improve its performance, user experience, and visual appeal. It involves analyzing the current website's strengths and weaknesses, identifying areas for improvement, and implementing changes to address user feedback, technological advancements, and evolving design trends. Website redesign aims to revitalize the online presence of a business or individual, optimizing navigation, usability, and engagement to better achieve desired goals and objectives.",
    },
    {
      id: uuidv4(),
      question: "What is UI/UX design?",
      answer:
        "UI (User Interface) design and UX (User Experience) design are disciplines focused on enhancing the visual appeal and usability of websites or applications, ensuring a positive experience for users.",
    },
    {
      id: uuidv4(),
      question: "What is a web development company?",
      answer:
        "A web development company is an organization that specializes in providing services related to website design, development, maintenance, and optimization for businesses or individuals.",
    },
    {
      id: uuidv4(),
      question: "What is application migration?",
      answer:
        "Application migration refers to the process of moving an application from one environment to another, such as migrating an application from on-premises servers to the cloud.",
    },
    {
      id: uuidv4(),
      question: "What is cloud migration?",
      answer:
        "Cloud migration involves transferring data, applications, and other business elements from on-premises infrastructure to cloud-based services, such as moving from local servers to platforms like AWS or Azure.",
    },
    {
      id: uuidv4(),
      question: "What is data migration?",
      answer:
        "Data migration is the systematic process of transferring data from one location, format, or system to another, ensuring the smooth transition of data while maintaining its integrity, accuracy, and security. It involves planning, extracting, transforming, and loading (ETL) data from the source to the target environment, often necessitating careful consideration of factors such as data compatibility, structure, and dependencies. Data migration aims to facilitate seamless data transitions, whether between storage systems, databases, applications, or cloud platforms, while minimizing disruptions and preserving data quality throughout the migration process.",
    },
    {
      id: uuidv4(),
      question: "What is Company Analytics?",
      answer:
        "Company Analytics refers to the practice of using data analytics tools and techniques to analyze and gain insights from a company's internal data sources, such as sales, marketing, finance, and operations data, to improve business performance and decision-making processes.",
    },
    {
      id: uuidv4(),
      question: "What is Business Analytics?",
      answer:
        "Business Analytics is the practice of using data analysis tools and techniques to explore and analyze past business performance, identify trends, forecast future outcomes, and drive data-driven decision-making within an organization to improve efficiency and profitability.",
    },
    {
      id: uuidv4(),
      question: "What is Data Analytics?",
      answer:
        "Data Analytics is the systematic exploration, interpretation, and transformation of raw data into valuable insights and actionable information. It involves employing a combination of statistical analysis, computational algorithms, and data visualization techniques to uncover patterns, trends, and relationships within datasets, ultimately aiding in informed decision-making, strategic planning, and operational optimization across various domains and industries.",
    },
  ];
  // return (
  //   <div className="px-5 sm:px-60 mt-10" id="faq">
  //     <h2 className="text-4xl font-bold text-center text-[#0D3559] mb-12 relative">
  //       Frequently asked Questions
  //       <span className="block w-24 h-1 bg-[#0d3559] mx-auto mt-3 rounded-full"></span>
  //     </h2>
  //     {webDevelopmentFAQs.map((item) => (
  //       <Accordion key={item.id}>
  //         <AccordionSummary
  //           expandIcon={<ExpandMoreIcon />}
  //           aria-controls="panel1-content"
  //           id="panel1-header"
  //           className="font-notosans font-bold"
  //         >
  //           {item.question}
  //         </AccordionSummary>
  //         <AccordionDetails className="font-notosans">
  //           {item.answer}
  //         </AccordionDetails>
  //       </Accordion>
  //     ))}
  //   </div>
  // );
};

export default DashboardFAQ;
